import { useEffect, useState } from 'react';

import { getIsMsgOutgoing, putInLocalStorage } from 'widget/actions';
import { useAccessToken } from '..';
import { useWidgetContext } from 'widget/widget-context';
import * as Env from 'widget/env';

import useInitialMessageList from './use-initial-message-list/use-initial-message-list';

const useMessageList = (): [Env.Message[], Env.SetState<Env.Message[]>] => {
  const { widget } = useWidgetContext();

  const initialMessageList = useInitialMessageList();
  const [messageList, setMessageList] = useState(initialMessageList);

  const { accessToken } = useAccessToken();

  const saveMessages = () => {
    const hasOutgoing = messageList.some(message =>
      getIsMsgOutgoing(accessToken, message),
    );

    if (!hasOutgoing) return;

    putInLocalStorage(
      `whatcrmWidgetMsgs${widget.instance_chat_key}`,
      JSON.stringify(messageList),
    );
  };

  useEffect(() => {
    saveMessages();
  }, [messageList]);

  return [messageList, setMessageList];
};

export default useMessageList;
